import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import Customerlist from "../Customerlist";

function AdminMember(){
    const[searchUi,setSearchUi]=useState(true)
    const[searchContent,setSearchContent]=useState('')
    return(

        <DataContext.Provider value={{searchUi,setSearchUi,searchContent,setSearchContent}}>
        <Navbar 
         navId={1}
        childrenPage={<Customerlist/>}/>
        </DataContext.Provider>
    )
}

export default AdminMember;